// extracted by mini-css-extract-plugin
export var typingIndicator = "_mm-0";